import EventTrackerAPI from '../src/event-tracker/api';

class EventTracking {
  static buildData(eventDescription, appId, sendToDatalake) {
    let data = { event_name: eventDescription }
    data['send_to_datalake'] = sendToDatalake;
    data['app_id'] = appId;

    return data;
  }

  static track(eventDescription, appId = null, sendToDatalake = false) {
    const data = EventTracking.buildData(eventDescription, appId, sendToDatalake);
    EventTrackerAPI.postTrackingEvent(data);
  }

  static trackAnonymous(eventDescription, appId = null, sendToDatalake = false) {
    const data = EventTracking.buildData(eventDescription, appId, sendToDatalake);
    EventTrackerAPI.postAnonymousTrackingEvent(data);
  }
}

export default EventTracking;
